export default "__VITE_ASSET__08da3165__"